import modules from "./_modules";

window.addEventListener('load', modules());
